import type { SVGProps } from 'react';

const Target = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 12.8334C10.6694 12.8334 12.8333 10.6694 12.8333 8.00002C12.8333 5.33064 10.6694 3.16669 8 3.16669C5.33062 3.16669 3.16667 5.33064 3.16667 8.00002C3.16667 10.6694 5.33062 12.8334 8 12.8334Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.8334C9.56481 10.8334 10.8333 9.56483 10.8333 8.00002C10.8333 6.43521 9.56481 5.16669 8 5.16669C6.43519 5.16669 5.16667 6.43521 5.16667 8.00002C5.16667 9.56483 6.43519 10.8334 8 10.8334Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.83335C8.46024 8.83335 8.83333 8.46026 8.83333 8.00002C8.83333 7.53978 8.46024 7.16669 8 7.16669C7.53976 7.16669 7.16667 7.53978 7.16667 8.00002C7.16667 8.46026 7.53976 8.83335 8 8.83335Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Target;
